import styled from 'styled-components';
import { maxWidth } from 'config/constants';

export const StyledIdentifyDevice = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props): string => props.theme.kcc.spacing.LG};
  height: 100%;
  max-width: ${(props): number => props.theme.kcc.screen.CONTENT_MAX_WIDTH}px;

  .identify-device__title {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.HEADING_3}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: 1.2;
    margin-bottom: 0;
  }

  .identify-device__subtitle {
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.BASE};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin-bottom: 0;
  }

  .identify-device__actions {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .identify-device__next-btn {
    display: flex;
    margin-left: auto;

    ${maxWidth.m} {
      margin: 0;
      width: 100%;
    }
  }

  .identify-device__next-btn-icon {
    display: flex;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
